module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "pro01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Prologue")])])]), _c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Welcome Back")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("H")])])])]), _vm._v("e didn’t know how long he’d been dead. There was no time, no season, no change, only eternity.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Shadows stumbled around him on the other side of the veil. Two in particular caught his attention. He knew what they were. He’d been one of them.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The life he craved was accessible to them. Now, as in his living death, he wanted to leech it from the mortals who couldn’t protect themselves. If he could envy this undead pair, he would, but there was no time. They had no life, so they were none of his concern.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("On the other side, they couldn’t see him. When he was of the world but not alive, he couldn’t see the ones who’d gone before him, either. Despite their sightlessness, they appeared to follow him. He moved away. He wanted life.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("It was a fool’s errand, his never-ceasing search for that mortal energy. It throbbed in the people and animals he passed every day, but he could not touch it. Thin though the veil was, it separated him from what he craved. He could reach for it, hold it in his hands, but the film of the shadow curtain always kept him from it.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Color, alien to this existence, would have shocked his senses, if he’d had any. The lifeless pair held something between them, shimmering and frightening like the fiery sword the angel held at the gates of Eden. It drew shadows to it like moths to the flame, though he hated such cliché description. He hated more that the thing drew him, as well. The shining rift split wider, and a hand, not full of life but real nonetheless, thrust through.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The other shadows clamored for it, sliding over it. Like water on oil, they rolled off the corporeal skin. As if searching specifically for him, the intruder pushed the others aside and grasped him. He stuck.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He hadn’t felt panic since he’d died. Hadn’t felt despair since her betrayal. He felt it now as the rough, real fingers pulled him through the rift.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Thick and heavy, feelings he’d almost forgotten happened all at once. Slippery and hot, sensations he remembered being pleasant at one time engulfed him. His formless being squeezed and conformed into a shape at once familiar and horrifyingly foreign.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Too bright. Too cold. Too real.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Too loud.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("One of the pair laughed like jagged glass. “We fucking did it! I can’t believe we fucking did it!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The light stung his eyes. He blinked, but his vision didn’t clear. In his chest, he felt a thump that hadn’t been a part of him for centuries—the beating of a human heart.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Alive. He was alive.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He dropped to the floor, screaming and clawing at his mortal prison.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The one who’d done it leaned over him and slapped him on the back. The connection of flesh against flesh drove needles of sensation to the bone.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Welcome back, Cyrus.”")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09fa4169","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bloodtiesbooktwopossession_pro01.vue
// module id = 69
// module chunks = 0